import React from 'react';

export const LanguageContext = React.createContext({});
export const LanguageProvider = LanguageContext.Provider;